// Smoothly scroll to a hash target, waiting for it to appear (async sections like
// the Events list render after a fetch) and offsetting for the fixed navbar.
export const scrollToHash = (hash, { offset = 90, timeout = 5000 } = {}) => {
  if (!hash) return;
  const start = Date.now();

  const doScroll = (el) => {
    const top = el.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
  };

  const tick = () => {
    const el = document.querySelector(hash);
    if (el) {
      doScroll(el);
      // Re-align once more after layout settles (images/animations shift height).
      setTimeout(() => {
        const again = document.querySelector(hash);
        if (again) doScroll(again);
      }, 450);
      return;
    }
    if (Date.now() - start < timeout) {
      setTimeout(tick, 120);
    }
  };

  tick();
};
